import { Flex, IconButton } from '@chakra-ui/react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { CSSProperties, createContext, useMemo } from 'react'

import { DraggableIcon } from '../Icons/DraggableIcon'
import { Tooltip } from '../Tooltip/Tooltip'

const SortableItemContext = createContext<any>({
  attributes: {},
  listeners: undefined,
  ref() {},
})

export const SortableItem = ({ disabled = false, ...props }: any) => {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isSorting,
  } = useSortable({ id: props.id, disabled })

  const context = useMemo(
    () => ({
      attributes,
      listeners,
      ref: setActivatorNodeRef,
    }),
    [attributes, listeners, setActivatorNodeRef],
  )

  const style: CSSProperties = {
    opacity: isDragging ? 1 : undefined,
    transform: CSS.Translate.toString(transform),
    transition,
  }

  return (
    <SortableItemContext.Provider value={context}>
      <Flex
        display="flex"
        ref={setNodeRef}
        style={style}
        alignItems="center"
        padding="8px"
        gap="6px"
        color="presets.neutral.30"
        _hover={{
          color: 'presets.turquoise.60',
        }}
        {...props}
      >
        {!disabled && (
          <Tooltip
            label="Drag To Reorder Columns"
            placement="left"
            isOpen={isSorting === true ? false : undefined}
            openDelay={1000}
          >
            <IconButton
              aria-label="Drag sort"
              variant="unstyled"
              cursor="grab"
              padding="8px 13px"
              lineHeight="1"
              marginLeft="-1px"
              minWidth="auto"
              {...listeners}
              {...attributes}
              icon={
                <DraggableIcon
                  height="17px"
                  width="12px"
                  color="presets.neutral.30"
                  _hover={{
                    color: 'presets.turquoise.60',
                  }}
                />
              }
            />
          </Tooltip>
        )}
        {props.children}
      </Flex>
    </SortableItemContext.Provider>
  )
}
